/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const pipelineStageMoveCandidatesDataSchema = z.object({
	destination: z.string(),
	candidateIds: z.array(z.string()),
})

export type PipelineStageMoveCandidatesDataSchema = z.infer<typeof pipelineStageMoveCandidatesDataSchema>
